import axios from "axios"

const URL =
  "https://my-json-server.typicode.com/yash0patni/issue_tracker_server"

class IssueApi {
  static async getAllIssue(searchString, cb) {
    const res = await axios.get(
      `${URL}/issues?_sort=lastUpdated&_order=desc${searchString}`
    )
    cb(res.data)
  }

  static async getIssue(issue) {
    const res = await axios.get(`${URL}/issues/${issue.id}`)
    return res.data
  }

  static async saveIssue(issue, cb) {
    const res = await axios.post(`${URL}/issues`, issue, {
      "Content-Type": "application/json",
    })
    cb(res.data)
  }

  static async editIssue(issue, cb) {
    const res = await axios.put(`${URL}/issues/${issue.id}`, issue, {
      "Content-Type": "application/json",
    })
    cb(res.data)
  }

  static async deleteIssue(issue, cb) {
    const res = await axios.delete(`${URL}/issues/${issue.id}`)
    console.log("deleteIssue IssueApi", res)
    cb(res.data)
  }
}

export default IssueApi
